function initAccordion() {


    let accordionCollapses = document.querySelectorAll('.accordion-collapse');

    let i = 1;

    accordionCollapses.forEach(accordionCollapse => {


        let sliderInit = false

   

        accordionCollapse.addEventListener('shown.bs.collapse', event => {

            let headerSliderAccordion = accordionCollapse.querySelector('.header-slider-accordion');

            if (headerSliderAccordion && !sliderInit) {

                _headerSlider.init(headerSliderAccordion);

                sliderInit = true;

            }
         
            var topY = offset(event.srcElement).top - 250;  

            //_scrollSmoother.scrollTo(topY)
                
             
            gsap.to(window, 0, {
                scrollTo:{
                    y: topY, 
                    //autoKill: true
                }, 
                delay:0.2,
                ease:Power2.easeInOut
             });
             
            

        })

        i++;

        
    });


    if (accordionCollapses) {

        window.onhashchange = function(){

            var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
            let accordionStellenItem = document.querySelector('[data-post-name="'+hash+'"]');

            if(accordionStellenItem) {
                modal.hide();
                setTimeout(function(){
                    simulateClick(accordionStellenItem);
                },200)
                
            }  

        };
       
        if(window.location.hash) {


            
            var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
            
            let accordionStellenItem = document.querySelector('[data-post-name="'+hash+'"]');

            console.log(accordionStellenItem); 

            if(accordionStellenItem) {
                setTimeout(function(){
                    simulateClick(accordionStellenItem);
                },200)
            }

        } 
    }

 
    
    
}